import SelectBoxHocSinhNew from "./SelectBoxHocSinhNew";
export default SelectBoxHocSinhNew
